import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
import FormatUtils from 'utils/format';
import { useAirportPriceExperiment } from './use-airport-price-experiment';
import UserUtils from 'utils/user-utils';
// During clean up or implementation, migrate to useLabel hook if possible instead of creating a new hook.
// This is created specifically for airport pirce experimentation
export const useLabelForAirport = spot => {
    const showTotal = useShowTotal();
    const { showSubtotal, hideTotalToggle } = useAirportPriceExperiment();
    const selectedRate = spot?.selectedRate || {};
    const defaultPrice = {
        value: 0,
        currencyCode: UserUtils.CURRENCY_TYPES.DEFAULT,
    };
    if (!showTotal && showSubtotal) {
        return 'Subtotal';
    }
    if (hideTotalToggle) {
        const advertisedPrice = selectedRate?.advertisedPrice || defaultPrice;
        const currencySymbol = FormatUtils.currencySymbol(advertisedPrice.currencyCode);
        const { dollars, cents } = FormatUtils.price(advertisedPrice.value);
        const formattedAdvertisedPrice = `${currencySymbol}${dollars.replace('-', '')}${cents ? `.${cents}` : ''} per day`;
        return formattedAdvertisedPrice;
    }
    return showTotal ? 'Total' : 'Per Day';
};
